import {ValidatorFn, AbstractControl } from '@angular/forms';

export const CustomMaxLength = (maxLength: any): ValidatorFn => {
  const message = `This field can not be larger than ${maxLength} characters`;


  return (control: AbstractControl): any => {

    if (!control.value) {
      return null;
    }

    return parseInt(control.value.length, 10) <= parseInt(maxLength, 10) ? null : {
      invalidMinLength: true,
      message: message
    };
  };

};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/max-length/max-length.validator.ts